import { render, staticRenderFns } from "./DepartmentsManager.vue?vue&type=template&id=864d5a9c&scoped=true&"
import script from "./DepartmentsManager.vue?vue&type=script&lang=ts&"
export * from "./DepartmentsManager.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentsManager.vue?vue&type=style&index=0&id=864d5a9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864d5a9c",
  null
  
)

export default component.exports